<template>
  <div class="pallet-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ riiContainerNo || 'No Container' }}</span>
          <span class="sub-title">Container</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ riiOrderNo }}</span>
          <span class="sub-title">Order</span>
        </div>
      </div>
      <div class="stats-info-card hash-brown-bg" v-if="isInWarehouse">
        <div class="info-card-left">
          <span class="title">{{ daysInWarehouse }} Days</span>
          <span class="sub-title">{{ InWarehouseDays }}</span>
        </div>
      </div>
      <div class="stats-info-card deep-yellow-bg" v-if="isUpcomming">
        <div class="info-card-left">
          <span class="title">{{ daysSinceUpcomming }} Days</span>
          <span class="sub-title">Still Upcomming</span>
        </div>
      </div>
      <div class="stats-info-card deep-yellow-bg" v-if="isShipped">
        <div class="info-card-left">
          <span class="title">Shipped</span>
          <span class="sub-title">Successfully</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PalletUpcoming,
  PalletOnStack,
  PalletOffStack,
  PalletOnStage,
  PalletShipping,
  PalletDelivered
} from '@/core/models/pallet'
import { palletStats } from '@/api/pallet'
import { dateDiff } from '@/core/utils'
const InWarehouseDays = 'In Warehouse'
export default {
  name: 'PalletDetailStats',
  props: {
    pallet: {
      type: Object,
      required: true
    },
    riiContainerNo: {
      type: String,
      required: true
    },
    riiOrderNo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      PalletUpcoming,
      PalletOnStack,
      PalletOffStack,
      PalletOnStage,
      PalletShipping,
      InWarehouseDays,
      palletStats: null
    }
  },
  mounted() {},
  watch: {
    palletId: {
      handler(value) {
        if (value) this.getPalletStats()
      },
      immediate: true
    }
  },
  computed: {
    palletId() {
      return this.pallet?.id ?? undefined
    },
    palletStatus() {
      return this.pallet?.status ?? undefined
    },
    isInWarehouse() {
      return [PalletOnStack, PalletOffStack, PalletOnStage].includes(
        this.palletStatus
      )
    },
    isShipped() {
      return [PalletShipping, PalletDelivered].includes(this.palletStatus)
    },
    isUpcomming() {
      return this.palletStatus === PalletUpcoming
    },
    daysSinceUpcomming() {
      return dateDiff(new Date(this.pallet.createdTime), new Date())
    },
    daysInWarehouse() {
      return this.palletStats?.daysInWarehouse ?? 0
    }
  },
  methods: {
    getPalletStats() {
      if (this.palletId) {
        palletStats(this.palletId).then(res => {
          this.palletStats = res
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
